define('SageDotCom/Components/LottieAnimationLottie',[
    "jquery", "eventManager"
],
    function ($, eventManager) {
        function LottieAnimation(scope) {
            var lottieEl = scope.querySelector("dotlottie-player");
            if (typeof lottieEl.getState === "undefined") {
                //Lottie functions not available
                return;
            }

            var lottieID = lottieEl.getAttribute("data-lottie");
            var lottieContainer = scope.querySelector(".lottie-container-" + lottieID);
            var lottieControl = lottieContainer.querySelector(".lottie-control");

            var isLoop = lottieContainer.querySelector(".lottie-controls").classList.contains("loop");
            var isReducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)')).matches;

            var resizeTimeout = null;
            var currentWidth = window.innerWidth;

            var finished = false;
            var loaded = false;

            setUpScrollObserver();

            function animationLoad() {
                if (loaded) return;

                var dataPath = lottieContainer.getAttribute("data-path");
                lottieEl.src = dataPath;
                lottieEl.load(lottieEl.src);
                loaded = true;
                $.fn.matchHeight._update();

                // we always want the buttons to be functional even in reduced motion as they have to be always visible now
                standardPlayPause();

                if (isReducedMotion) {
                    function checkReducedMotion() {
                        if (isReducedMotion) {
                            lottieEl.seek("100%");
                        }
                    }
                    lottieEl.addEventListener('ready', checkReducedMotion());
                }
                else {
                    //already scrolled into view (hence the loading) so just play when loaded
                    lottieEl.addEventListener('ready', play());

                    //pick up tabset panel changes and parallax scroll changes
                    eventManager.subscribe("lottie-load", function (scope) {
                        // check for inside tabset or parallax scroll 
                        // pause all animations unless the animation is in active panel
                        pause();
                        var isInActiveTabsetPanel = $(lottieEl).parents(".score-tab") && $(lottieEl).parents(".score-tab").is(":visible");
                        var isInActiveParallaxPanel = $(lottieEl).parents(".fixed-scroll__media .is-active") !== null && $(lottieEl).parents(".fixed-scroll__media .is-active").length > 0;
                        if (isInActiveTabsetPanel || isInActiveParallaxPanel) {
                            play();
                        }
                    }, this);
                }
            }

            $(window).on("resize",
                function () {
                    if (loaded && window.innerWidth !== currentWidth) {
                        if (resizeTimeout) {
                            clearTimeout(resizeTimeout);
                        }
                        resizeTimeout = setTimeout(function () {
                            currentWidth = window.innerWidth;
                            lottieEl.load(lottieEl.src);
                            $.fn.matchHeight._update();
                        },
                            500);
                    }
                });

            // scroll observer
            function setUpScrollObserver() {
                function checkIfVisible(entries) {
                    entries.map((entry) => {
                        if (entry.isIntersecting) {
                            animationLoad();
                            observer.unobserve(entry.target);
                        }
                    });
                }

                var options = {
                    rootMargin: "200px", // preload before entering viewport
                    threshold: 0.25
                };
                var observer = new IntersectionObserver(checkIfVisible, options);
                observer.observe(lottieEl);
            }

            // helper functions for setting up lottie functionality
            function standardPlayPause() {
                lottieControl.addEventListener("click", function (e) {
                    if (lottieControl.classList.contains("playing")) {
                        pause();
                    } else {
                        play();
                    }
                });

                // loop functionality and allow users to play animation again
                lottieEl.addEventListener('complete', function (e) {
                    finished = true;
                    lottieControl.classList.remove("playing");
                    if (isLoop && !isReducedMotion) {
                        play();
                    }
                });
            }

            function pause() {
                lottieControl.classList.remove("playing");
                lottieEl.pause();
            }

            function play() {
                // handles play/pause button icon change and triggers lottie safePlay check
                if (finished === true) {
                    lottieEl.stop();
                }
                lottieControl.classList.add("playing");
                safePlay(lottieEl);
                finished = false;
            }

            function safePlay(el) {
                el = el || lottieEl;
                if (!el || typeof el.getState !== "function") return;

                var stateObj = el.getState();
                var state = stateObj && stateObj.currentState;

                if (state === "loading" || !state) {
                    addOnce(el, "ready", function () {
                        try { el.play(); } catch (e) { console.error("dotlottie play after ready failed", e); }
                    });
                    addOnce(el, "loadError", function (ev) {
                        console.error("dotlottie loadError", ev && ev.detail ? ev.detail : ev);
                    });
                    addOnce(el, "error", function (ev) {
                        console.error("dotlottie error", ev && ev.detail ? ev.detail : ev);
                    });
                } else if (state === "ready" || state === "paused" || state === "stopped") {
                    try { el.play(); } catch (e) { console.error("dotlottie play failed", e); }
                } else {
                    addOnce(el, "ready", function () {
                        try { el.play(); } catch (e) { console.error("state unknown, attempting to play failed", e); }
                    });
                }
            }

            function addOnce(el, evtName, handler) {
                var wrapped = function (e) {
                    try { handler(e); } finally { el.removeEventListener(evtName, wrapped); }
                };
                el.addEventListener(evtName, wrapped);
            }            
        }

        LottieAnimation.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new LottieAnimation(args.scope);
        };

        return LottieAnimation;
    });
